// extracted by mini-css-extract-plugin
module.exports = {"flash":"Flash_flash__7I6pH","bulle":"Flash_bulle__2p0FE","iconBulle":"Flash_iconBulle__2Ddew","iconText":"Flash_iconText__3xd-k"};